import { useCallback, useEffect, useRef, useState } from 'react';
import {
  createSportsbookHistoryCancelCommand,
  getSportsbookHistoryErrorMessage,
  isStaleSportsbookHistoryCommandError,
  requestSportsbookHistoryCancel,
} from '../api/sportsbookHistoryRequest.api.js';

export const useSportsbookHistoryCancel = ({ service, onRefresh }) => {
  const [cancelingHistoryId, setCancelingHistoryId] = useState('');
  const requestRef = useRef({ controller: null, generation: 0 });
  const refreshRef = useRef(onRefresh);
  refreshRef.current = onRefresh;

  useEffect(() => () => requestRef.current.controller?.abort(), []);

  const cancel = useCallback(async (row) => {
    if (row?.capabilities?.can_cancel !== true) return null;
    requestRef.current.controller?.abort();
    const controller = new AbortController();
    const generation = requestRef.current.generation + 1;
    requestRef.current = { controller, generation };
    setCancelingHistoryId(row.history_id);

    try {
      await requestSportsbookHistoryCancel({
        service,
        historyId: row.history_id,
        command: createSportsbookHistoryCancelCommand(row.row_version),
        signal: controller.signal,
      });
      if (controller.signal.aborted || requestRef.current.generation !== generation) return null;
      refreshRef.current?.(row);
      return { ok: true, error: '' };
    } catch (error) {
      if (controller.signal.aborted || error?.name === 'AbortError' || requestRef.current.generation !== generation) return null;
      if (isStaleSportsbookHistoryCommandError(error)) refreshRef.current?.(row);
      return { ok: false, error: getSportsbookHistoryErrorMessage(error, '취소 실패') };
    } finally {
      if (!controller.signal.aborted && requestRef.current.generation === generation) setCancelingHistoryId('');
    }
  }, [service]);

  return { cancel, cancelingHistoryId };
};
